import { getWithUrl } from 'src/utils/http';

const API_URL = {
    SEARCH: 'https://ac-data.baomoi.com/get',
};

export type TSearchType =
    | 'content'
    | 'topic'
    | 'keyword'
    | 'category'
    | 'publisher';

export interface ISearchParams {
    query: string;
    platform: number;
    types: TSearchType;
    size?: number;
}

export type TSuggestItem = { value: string; id: string };

export const SearchServices = {
    searchTopic: (query: string): Promise<{ topic: TSuggestItem }> => {
        const params: ISearchParams = { platform: 1, types: 'topic', query };
        return getWithUrl(API_URL.SEARCH, params) as any;
    },
    searchContent: (query: string): Promise<{ article: TSuggestItem }> => {
        const params: ISearchParams = {
            platform: 1,
            types: 'content',
            query,
            size: 6,
        };
        return getWithUrl(API_URL.SEARCH, params) as any;
    },
    searchKeyword: (
        query: string,
        size = 6
    ): Promise<{ keyword: TSuggestItem }> => {
        const params: ISearchParams = {
            platform: 1,
            types: 'keyword',
            query,
            size,
        };
        return getWithUrl(API_URL.SEARCH, params) as any;
    },
    searchCategory: (
        query: string,
        size = 6
    ): Promise<{ category: TSuggestItem }> => {
        const params: ISearchParams = {
            platform: 1,
            types: 'category',
            query,
            size,
        };
        return getWithUrl(API_URL.SEARCH, params) as any;
    },
    searchPublisher: (
        query: string,
        size = 6
    ): Promise<{ publisher: TSuggestItem }> => {
        const params: ISearchParams = {
            platform: 1,
            types: 'publisher',
            query,
            size,
        };
        return getWithUrl(API_URL.SEARCH, params) as any;
    },
};
